import * as R from 'ramda';

/**
 * It assigns a default value for a function to avoid unsafe JS code
 * @param func
 * @param defaultValue
 */
const safeRamda = (func: (x: any) => {}, defaultValue: any) =>
  R.compose(func, R.defaultTo(defaultValue));

/**
 * Common use cases
 */
const map = (arg: any) => safeRamda(R.map(arg), []);
const mapIndexed = (arg: any) => safeRamda(R.addIndex(R.map)(arg), []);
const sortBy = (arg: (arg: any) => R.Ord) => safeRamda(R.sortBy(arg), []);
const reject = (arg: (value: any) => boolean) => safeRamda(R.reject(arg), []);
const filter = (arg: (value: any) => boolean) => safeRamda(R.filter(arg), []);

export { safeRamda, map, mapIndexed, sortBy, reject, filter };
